import { useFormik } from 'formik';
import * as Yup from 'yup';

const optionalCurrency = Yup.mixed()
  .notRequired()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue === undefined || originalValue === null) {
      return '';
    }
    if (typeof originalValue === 'string') {
      return Number(originalValue.replace(/\./g, ''));
    }
    return value;
  })
  .test('is-number-or-empty', 'Debe ser un número válido', (value) => {
    if (value === undefined || value === null || value === '') return true;
    return !isNaN(value);
  });

export function useCompletedValidation(onSubmit) {
  const initialValues = {
    date: '',
    price: '',
    paymentMethod: '',
    comment: '',
    comisionCliente: '',
    comisionProveedor: '',
    valorNeto: '',
    gastoTransferencia: '106.500',
    impuestoTransferencia: '',
    iva: '',
    tag: '25.000',
    documento: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      date: Yup.date().required('El campo fecha es requerido'),
      price: Yup.mixed()
        .required('El campo precio es requerido')
        .transform((value, originalValue) => {
          if (typeof originalValue === 'string') {
            // Convert value with format (24.000.000) to number (24000000)
            return Number(originalValue.replace(/\./g, ''));
          }
          return value;
        })
        .test(
          'is-number',
          'El precio debe ser un número válido',
          (value) => !isNaN(value),
        ),
      paymentMethod: Yup.string().required(
        'El campo forma de pago es requerido',
      ),
      comment: Yup.string().required('El campo comentario es requerido'),
      comisionCliente: optionalCurrency,
      comisionProveedor: optionalCurrency,
      valorNeto: optionalCurrency,
      gastoTransferencia: optionalCurrency,
      impuestoTransferencia: optionalCurrency,
      iva: optionalCurrency,
      tag: optionalCurrency,
      documento: Yup.string().required('El campo documento es requerido'),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
